module.exports = __webpack_public_path__ + "img/fxq.7af3703f.png";